import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import styled from "styled-components";

import CallService from "../../services/callService";

const useFetch = (range, userId, departmentId) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await CallService.fetchStatusAggregate({
        startDate: range.start,
        endDate: range.end,
        assigned_to: userId,
        department: departmentId
      });
      setData(result);
    };
    fetchData();
  }, [departmentId, range.end, range.start, userId]);
  return { data };
};

export const StyledCircle = styled.div`
  width: ${(props) => (props.isMobile ? "135px" : "160px")};
  height: ${(props) => (props.isMobile ? "135px" : "160px")};

  border-radius: 50%;
  position: relative;
  overflow: hidden;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  &:hover {
    transform: scale(1.02);
    &:before {
      opacity: 0.8;
    }
  }
  &:before {
    content: "";
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-color: ${(props) => props.color};
    background-color: ${(props) => props.color};
    position: absolute;
    width: 100%;
    height: 100%;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  div {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
  }
`;

const DashboardCallStatus = ({
  codes,
  userId,
  departmentId,
  history,
  range,
  user,
  department,
  isMobile,
  dragState
}) => {
  const { data: aggregateStatus } = useFetch(range, userId, departmentId);

  const handleStatusClick = (status) => () => {
    if (!dragState.dragInProcess && dragState.dragOver) {
      const stage = [];
      if (status.stage === "Completed") {
        codes
          .filter(
            (code) =>
              code.entity === "Call" &&
              code.field === "status" &&
              code.label !== "Reserved"
          )
          .forEach((code) => stage.push({ label: code.label, value: code.id }));
      } else if (status.stage === "Reserved") {
        codes
          .filter(
            (code) =>
              code.entity === "Call" &&
              code.field === "status" &&
              code.label === "Reserved"
          )
          .forEach((code) => stage.push({ label: code.label, value: code.id }));
      }
      const newFilters = {
        multi_assigned_to:
          user && user.value ? [{ label: user.label, value: user.value }] : [],
        stage,
        department:
          department && department.value
            ? [{ label: department.label, value: department.value }]
            : [],
        arrival_date: new Date(range.start).toString(),
        completed_date: new Date(range.end).toString()
      };

      localStorage.setItem("filters", JSON.stringify(newFilters));

      history.push(`/app/calls`);
    }
  };
  return (
    <React.Fragment>
      <div className="content-wrapper">
        <div className="dashboard-call-status-row">
          {aggregateStatus.map((status, id) => (
            <StyledCircle
              key={id}
              color={status.color}
              isMobile={isMobile}
              onClick={handleStatusClick(status)}
            >
              <div>
                <h1 className="title">{status.total}</h1>
                <h2 className="subtitle">{status.stage}</h2>
              </div>
            </StyledCircle>
          ))}
        </div>
      </div>
      {/* <pre>
        <code>{JSON.stringify(aggregateStatus, null, 2)}</code>
      </pre> */}
    </React.Fragment>
  );
};

DashboardCallStatus.propTypes = {
  history: PropTypes.object,
  range: PropTypes.object,
  codes: PropTypes.array,
  userId: PropTypes.string,
  departmentId: PropTypes.string,
  user: PropTypes.object,
  department: PropTypes.object,
  isMobile: PropTypes.bool,
  dragState: PropTypes.object
};

DashboardCallStatus.defaultProps = {
  range: {},
  dragState: {}
};
export default DashboardCallStatus;
